import { ref } from 'vue';

const paymentDialogVisible = ref(false);

export function usePaymentDialog() {
  function showPaymentDialog() {
    paymentDialogVisible.value = true;
  }

  function hidePaymentDialog() {
    paymentDialogVisible.value = false;
  }

  return {
    paymentDialogVisible,
    showPaymentDialog,
    hidePaymentDialog,
  };
}
